import { ref as l, computed as u, inject as n } from "vue";
const s = Symbol("isDesktop"), t = Symbol("isMobile"), a = {
  install(i, { mql: e }) {
    if (!e)
      throw new Error(
        "ScreenSizePlugin requires a MediaQueryList instance."
      );
    const o = l(e.matches), r = u(() => !o.value);
    e.addEventListener("change", ({ matches: c }) => {
      o.value = c;
    }), i.provide(s, o), i.provide(t, r);
  }
};
function p() {
  const i = n(s), e = n(t);
  if (!i || !e)
    throw new Error("ScreenSizePlugin not properly installed.");
  return { isDesktop: i, isMobile: e };
}
export {
  a as ScreenSizePlugin,
  s as isDesktopKey,
  t as isMobileKey,
  p as useScreenSize
};
